import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import InfinityProgressBar from "common/components/InfnityProgressBar"
import Modal from "common/components/Modal/Modal"
import { useTranslation } from "react-i18next"
import { MODAL_TYPE_KEYS } from "../../constants"
import "./style.scss"

const LoadingModal = ({ showModal, onHideModal, data }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { title, message, icon, type } = data

  return (
    <Modal
      size='xsmall'
      className='loading-modal'
      visible={showModal}
      onHide={onHideModal}
      closable={false}
      draggable={false}
      header={
        <div className='loading-modal__header-container d-flex align-items-center'>
          <div className='loading-modal__icon d-flex align-items-center justify-content-center'>
            <span className='d-flex align-items-center justify-content-center'>
              <FontAwesomeIcon icon={["fal", icon]} />
            </span>
          </div>
          <h4 className='loading-modal__title'>{title}</h4>
          <p className='loading-modal__text'>{message}</p>
        </div>
      }
    >
      <div className='mt-3 loading-modal__content'>
        <InfinityProgressBar />
        {type === MODAL_TYPE_KEYS.REDIRECT ? (
          <span className='loading-modal__cancel-button'>
            <p onClick={() => onHideModal?.()}>
              {t("bancos.modal.cancelButton")}
            </p>
          </span>
        ) : null}
      </div>
    </Modal>
  )
}

export default LoadingModal
